var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedallionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 38,
    viewBox: "0 0 230 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6611 24.0449C40.6611 15.7731 46.7596 10.083 54.5703 10.083C60.6227 10.083 68.1173 13.6525 68.1173 23.3731C68.1173 24.0449 68.0119 25.283 67.9131 25.9087H47.8528C48.4192 30.2026 51.0601 32.3693 54.623 32.3693C57.5669 32.3693 59.5887 31.0258 60.7741 28.701H67.9065C66.0954 34.9575 60.9256 38.0068 54.5703 38.0068C46.7662 38.0068 40.6611 32.3693 40.6611 24.0449ZM61.189 21.2525C60.5173 17.8938 57.883 15.7731 54.6757 15.7731C51.4684 15.7731 48.7287 18.256 48.0043 21.2525H61.189Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9355 24.0449C70.9355 15.7732 76.4676 10.0831 83.3959 10.0831C86.7546 10.0831 89.6524 11.3212 91.5622 13.804V1.03418H98.5432V37.2231H91.9245V34.1739C89.7511 36.8082 86.9588 38.0002 83.3432 38.0002C76.3096 38.0002 70.9355 32.1586 70.9355 24.0383V24.0449ZM78.068 24.0449C78.068 29.0106 81.1172 32.3694 85.0489 32.3694C88.9806 32.3694 91.9771 28.9579 91.9771 24.0449C91.9771 19.1319 88.9806 15.7732 85.0489 15.7732C81.1172 15.7732 78.068 19.1319 78.068 24.0449Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.625 24.0449C101.625 15.7731 107.157 10.083 114.085 10.083C117.444 10.083 120.342 11.275 122.252 13.7513V10.8535H129.233V37.223H122.614V34.2265C120.441 36.8608 117.648 38.0002 114.033 38.0002C106.999 38.0002 101.625 32.1586 101.625 24.0383V24.0449ZM108.757 24.0449C108.757 29.0106 111.807 32.3693 115.738 32.3693C119.67 32.3693 122.667 28.9579 122.667 24.0449C122.667 19.1319 119.67 15.7731 115.738 15.7731C111.807 15.7731 108.757 19.1319 108.757 24.0449Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.804 1.03418H140.785V37.2231H133.804V1.03418Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19 1.03418H152.171V37.2231H145.19V1.03418Z",
    fill: "#0C1A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.252 0C162.577 0 164.335 1.70572 164.335 3.93172C164.335 6.15771 162.577 7.81075 160.252 7.81075C157.927 7.81075 156.169 6.10503 156.169 3.93172C156.169 1.75841 157.875 0 160.252 0ZM156.735 10.86H163.716V37.2295H156.735V10.86Z",
    fill: "#0C1A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.498 10.083C189.513 10.083 195.559 15.8719 195.559 24.0449C195.559 32.2178 189.559 38.0068 181.498 38.0068C173.437 38.0068 167.438 32.2178 167.438 24.0449C167.438 15.8719 173.384 10.083 181.498 10.083ZM181.498 32.3693C185.476 32.3693 188.426 29.0632 188.426 24.0449C188.426 19.0265 185.476 15.7731 181.498 15.7731C177.52 15.7731 174.57 19.0792 174.57 24.0449C174.57 29.0106 177.468 32.3693 181.498 32.3693Z",
    fill: "#0C1A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.286 10.8601H206.109V14.2189C208.592 11.3738 211.489 10.083 215.052 10.083C221.052 10.083 224.305 13.4418 224.305 20.2185V37.2296H217.324V21.562C217.324 17.9925 215.513 15.9246 212.207 15.9246C208.901 15.9246 206.26 18.3021 206.26 22.1811V37.2296H199.279V10.8601H199.286Z",
    fill: "#0C1A68"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2617 7.98877L35.6427 1.3042H27.0811L21.8125 17.0442L36.2617 7.98877Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0374 17.0113L11.8478 1.3042H3.33241L2.67383 8.37734L17.0374 17.0113Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20624 13.4351L0 37.2032H7.53414L8.68007 21.1997L2.20624 13.4351Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4463 23.2678L31.3881 37.2033H38.9749L37.0782 16.7939L30.4463 23.2678Z",
    fill: "#4795C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.631836 9.02925L19.5199 20.3831L51.8232 0.14502L19.5133 31.6844L0.631836 9.02925Z",
    fill: "#0C1A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.568 10.8335H226.682V11.3867H225.905V13.83H225.345V11.3867H224.568V10.8335Z",
    fill: "#0C1A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.124 10.8335H227.757L228.323 12.5853H228.329L228.889 10.8335H229.528L229.778 13.83H229.212L229.08 11.6699H229.074L228.514 13.402H228.132L227.579 11.6699H227.572L227.434 13.83H226.874L227.124 10.8335Z",
    fill: "#0C1A68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229.778,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedallionLogo);
export default __webpack_public_path__ + "static/media/Medallion_Logo.84a3d49d0e375b407c221b965272d75d.svg";
export { ForwardRef as ReactComponent };